module.exports = __webpack_public_path__ + "media/images/p_big1-46073afc1cf97972ea4a55931e328c35.jpg";